<template>
    <div class="mx-2 mx-lg-5">
        <div class="card">
            <div class="card-header">
                <h3>{{ $t("headers.vehicles") }}</h3>
            </div>
            <div class="card-body p-0">
                <table class="table table-striped table-hover table-responsive-md">
                    <thead>
                        <tr>
                            <th>{{ $t("vehicleEntry.carrier") }}</th>
                            <th>{{ $t("vehicleEntry.driver_name") }}</th>
                            <th>{{ $t("vehicleEntry.licencePlate") }}</th>
                            <th>{{ $t("vehicleEntry.from") }}</th>
                            <th>{{ $t("vehicleEntry.to") }}</th>
                            <th>{{ $t("status.status") }}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="vehicle in vehicleEntries"
                            :key="vehicle.id"
                            @click="goToVehicleDetail(vehicle, $event)"
                            style="cursor: pointer;"
                        >
                            <td>{{ vehicle.carrier }}</td>
                            <td>{{ vehicle.driver_name }}</td>
                            <td>{{ vehicle.licence_plate }}</td>
                            <td>{{ vehicle.expected_from ? $d(new Date(vehicle.expected_from), 'short') : "—" }}</td>
                            <td>{{ vehicle.expected_to ? $d(new Date(vehicle.expected_to), 'short') : "—" }}</td>
                            <td>
                                <div v-if="$store.getters.hasGatehousePerm('change_status_vehicleentry')">
                                    <select class="form-select" @change="changeStatus(vehicle)" v-model="vehicle.status">
                                        <option
                                            v-for="status in statuses"
                                            :key="status.id"
                                            :value="status.id"
                                        >
                                            {{ $t("status.vehicleEntry." + status.name) }}
                                        </option>
                                    </select>
                                </div>
                                <div v-else>
                                    {{ $t("status.vehicleEntry."+ vehicle.status_name) }}
                                </div>
                            </td>
                            <td>
                                <!-- warning -->
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                vehicleEntries: [],
                statuses: [],
            }
        },
        created() {
            this.getVehicleEntry();
            this.getStatuses();
        },
        methods: {
            getVehicleEntry() {
                this.$store.getters.api.get(`/${this.$route.params.slug}/vehicle-entries`)
                .then(response => {
                    this.vehicleEntries = response.data;
                })
                .catch(error => {
                    console.error("Error loading vehicle entries", error);
                });
            },
            getStatuses() {
                this.$store.getters.api.get(`/${this.$route.params.slug}/statuses`, {
                    params: {model: "vehicleentry"}
                })
                .then(response => {
                    this.statuses = response.data;
                })
                .catch(error => {
                    console.error("Error loading statuses", error);
                });
            },
            changeStatus(vehicle) {
                const slug = this.$route.params.slug;
                const vehicleId = vehicle.id;
                const statusId = vehicle.status;

                const url = `/${slug}/vehicle-entries/${vehicleId}/status/edit`;
                const dataPost = { status: statusId };

                this.$store.getters.api.patch(url, dataPost)
                .catch(error => {
                    console.error("Failed to update status", error)
                });
            },
            goToVehicleDetail(vehicle, event) {
                if (event.target.closest("select")) {
                    return;
                }

                this.$router.push({
                    name: "vehicleEntryDetailView",
                    params: {
                        slug: this.$route.params.slug,
                        id:vehicle.id,
                    }
                });
            },
        },
    }
</script>